import { connect } from "react-redux";
import { getAutocompleteCustomer, getDetailCustomer } from "actions/Customer";
import { getListPhiKhac } from "actions/PhiKhac";
import { getListPhiKhacHangKy } from "actions/PhiKhacHangKy";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
import {
  postTraGop,
  setEnableEditCustomer,
  setChoVayEdit,
  checkEditCustomer,
} from "actions/ThemMoiBanHangTraGop";
import { getDetailCustomerSuccess } from "actions/Customer";
import ThemMoiBanHangTraGop from "../../../components/BanHangTraGop/ThemMoi";

const mapStateToProps = (state) => ({
  customer: state.customer,
  user: state.user,
  phikhac: state.phikhac,
  phikhachangky: state.phikhachangky,
  loaitaisan: state.loaitaisan,
  thuoctinhtaisan: state.thuoctinhtaisan,
  store: state.store,
  nguonkhachhang: state.nguonkhachhang,
  camdo: state.camdo,
  cauhinh: state.cauhinh,
  taisan: state.taisan,
  themmoitragop: state.themMoiBanHangTraGop,
  phanquyen: state.phanquyen,
  quanlycuahang: state.quanlycuahang,
});

const mapDispatchToProps = (dispatch) => ({
  getAutocompleteCustomer: (dataSearch) =>
    dispatch(getAutocompleteCustomer(dataSearch)),
  getListPhiKhac: (dataSearch) => dispatch(getListPhiKhac(dataSearch)),
  getListPhiKhacHangKy: (dataSearch) =>
    dispatch(getListPhiKhacHangKy(dataSearch)),
  getComboNguonKhachHang: () => dispatch(getComboNguonKhachHang()),
  postTraGop: (dataPost) => dispatch(postTraGop(dataPost)),
  getDetailCustomer: (dataSearch) => dispatch(getDetailCustomer(dataSearch)),
  setChoVayEdit: (data) => dispatch(setChoVayEdit(data)),
  checkEditCustomer: (data) => dispatch(checkEditCustomer(data)),
  setEnableEditCustomer: (data) => dispatch(setEnableEditCustomer(data)),
  getDetailCustomerSuccess: (data) => dispatch(getDetailCustomerSuccess(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemMoiBanHangTraGop);
